import { BrowserRouter } from "react-router-dom";
import Router from "./Router";
import ScrollToTop from "./ScrollToTop";
import GAWrapper from "../analytics/GAWrapper";
import Consent from "../analytics/Consent";
import GAInitializer from "../analytics/GAInitializer";
import { PagePreviewProvider } from "../context/PageInfoContext";

export default function App() {
  	return (
		<PagePreviewProvider>
			<BrowserRouter>
				<ScrollToTop />
				<Consent />
				<GAInitializer />
				<GAWrapper>
					<Router />
				</GAWrapper>
			</BrowserRouter>
		</PagePreviewProvider>
  	);
}